import { HStack, Show } from "@chakra-ui/react";
import APButton from "./APButton";
import { AlloprofLogo, Wallpaper } from "./APAssetAtlas";
import React from "react";
import { useSettingsContext } from "../contexts/SettingsContext";
import { useVocabIntl } from "../hooks/useVocabTranslation";

export default function APFooter() {
  const { setProfileOpen, setDefaultProfileTab } = useSettingsContext();
  const { APFormattedMessage } = useVocabIntl();
  return (
    <HStack justifyContent={{ base: "center", md: "space-between" }} layerStyle={"pageFooter"}>
      <Show above={"md"}>
        <APButton variant={"outline"} colorScheme={"tertiary"} size={"md"} fontSize={"sm"} gap={2}
                  onClick={() => {
                    setDefaultProfileTab(1)
                    setProfileOpen(true)
                  }}>
          <Wallpaper />
          <APFormattedMessage id={"wallpaper-button"} />
        </APButton>
      </Show>
      <AlloprofLogo width={"auto"} height={["2rem", "2.5rem"]} margin={"0.25rem 1rem"} style={{ color: "white" }} />
    </HStack>)
}